// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {
	// Check if module is in cache
	var cachedModule = __webpack_module_cache__[moduleId];
	if (cachedModule !== undefined) {
		return cachedModule.exports;
	}
	// Create a new module (and put it into the cache)
	var module = __webpack_module_cache__[moduleId] = {
		id: moduleId,
		// no module.loaded needed
		exports: {}
	};

	// Execute the module function
	__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	// Return the exports of the module
	return module.exports;
}

// expose the modules object (__webpack_modules__)
__webpack_require__.m = __webpack_modules__;

// the startup function
__webpack_require__.x = () => {
	// Load entry module and return exports
	// This entry module depends on other loaded chunks and execution need to be delayed
	var __webpack_exports__ = __webpack_require__.O(undefined, [2962,1040,4387], () => (__webpack_require__("./src/workers/indexeddb.worker.ts")))
	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
	return __webpack_exports__;
};

